import { Component, AfterViewInit, Output, EventEmitter, Input } from '@angular/core';
import { SQLService } from '../../../services/sql.service';
import { backgrounds, backgrounds_lowrez } from '../../../../environments/logos';
@Component({
  selector: 'app-cheque-statue-of-liberty',
  templateUrl: './cheque-statue-of-liberty.component.html',
  styleUrls: ['./cheque-statue-of-liberty.component.scss'],
})
export class ChequeStatueOfLibertyComponent implements AfterViewInit {
  constructor(private sql: SQLService) { }
  @Output('loaded') loaded = new EventEmitter<boolean>();
  @Input('RenderMICR') RenderMICR = false;
  @Input('ImageMICR') ImageMICR = true;
  @Input('show') show = 'table';
  @Input('cheque') cheque: any;
  @Input('design') design: any;
  @Input('designer') designer: any;
  @Input('rotate') rotate: boolean;
  @Input('borders') borders: boolean;
  @Input('voidcheck') voidcheck: boolean;
  @Input('font') font: any;
  @Input('fiat') fiat: boolean;
  @Input('color') color: any;
  @Input('micr') micr: any;
  micr_top=false;
  micr_right=false;
  micr_bottom='5.5mm';
  micr_left='10mm';
  @Input('secret') secret = '';
  @Input('scale') scale =1;
  @Input('fold_line') fold_line: boolean;
  @Input('template') template: string;
  @Input('monochrome') monochrome: boolean;
  @Input('gradients') gradients: boolean;
  @Input('margin_bottom') bottom = '0mm';
  @Input('margin_top') top = '0mm';
  @Input('fontsize') fontsize: boolean;
  @Input('layers') layers: any;
  @Input('translations') translations = this.sql.word;
  @Input('bold') bold: boolean;
  @Input('italic') italic: boolean;
  @Input('show_cheque_number') show_cheque_number: boolean = true;
  @Input('show_cheque_date') show_cheque_date: boolean = true;
  @Input('show_micr') show_micr: boolean = true;
  @Input('cheque_background_image_repeat') cheque_background_image_repeat = false;
  @Input('background_position') background_position: string;
  @Input('cheque_text_color') cheque_text_color: string;
  @Input('cheque_background_image') cheque_background_image: any;
  @Input('cheque_logo_image') cheque_logo_image: any;
  @Input('cheque_header_image') cheque_header_image: any;
  @Input('cheque_bank_image') cheque_bank_image: any;
  @Input('doc_color') doc_color: string = 'yellow';
  bg_image: string;
  loaded_component() {this.loaded.emit(true);}
  ngAfterViewInit() {
    this.design["date"]["top"]='12.5mm';
    this.design["date"]["right"]='25.1mm'; 
    this.design["date"]["alternative_2"]=true;
    this.design["date_label"]["display"]=false;
    this.design["payline"]["prefix"]=false;
    this.design["payline"]["borders"]=false;
    this.design["payline"]["top"]='24.2mm';
    this.design["payline"]["right"]='27px';
    this.design["payline"]["bottom"]='4px';
    this.design["payline"]["left"]='26mm';
    this.design["printed_id"]["top"]='6mm';
    this.design["printed_id"]["right"]='7mm';
    this.design["payment_name"]["left"]="-5px";
    this.design["payment_name"]["bottom"]="0px";
    this.design["written_amount"]["top"]='36.4mm';
    this.design["written_amount"]["right"]='30px';
    this.design["written_amount"]["bottom"]='39mm';
    this.design["written_amount"]["left"]='9.5mm';
    this.design["written_amount"]["index"]=false;
    this.design["written_amount_line"]["width"]='550px';
    this.design["written_amount_line"]["borders"]=false;
    this.design["written_amount_line"]["overflow"]=true;
    this.design["written_amount_line"]["top"]='0px';
    this.design["written_amount_line"]["right"]='0px';
    this.design["written_amount_line"]["bottom"]='0px';
    this.design["written_amount_line"]["left"]='0px';
    this.design["multiline_written_amount_chars"]=67;
    this.design["written_amount_line2"]["top"]='4.4mm'
    this.design["written_amount_line2"]["right"]='0mm'
    this.design["written_amount_line2"]["bottom"]='0mm'
    this.design["written_amount_line2"]["left"]='0mm'
    this.design["amount_number"]["top"]="2.7mm";
    this.design["amount_number"]["right"]="auto";
    this.design["amount_number"]["left"]="2.7mm";
    this.design["amount_number"]["borders"]=false;
    this.design["amount_number"]["background"]=false;
    this.design["amounts"]["symbol"]=false;
    this.design["memo"]["label"]=false;
    this.design["memo"]["border"]=false;
    this.design["memo"]["left"]='8mm';
    this.design["memo"]["bottom"]='12mm';
    this.design["bank_image"]["top"]='50px';
    this.design["bank_image"]["left"]='40px';
    this.design["bank_name"]["top"]='47.6px';
    this.design["bank_name"]["left"]='91px';
    this.design["bank_address"]["top"]='61px';
    this.design["bank_address"]["left"]='91.3px';
    this.design["bank_address_2"]["top"]='72px';
    this.design["bank_address_2"]["left"]='91.3px';
    this.design["bank_address_3"]["top"]='83px';
    this.design["bank_address_3"]["left"]='91.3px';
    this.design["public_image"]["top"]='32.5mm';
    this.design["public_image"]["left"]='auto';
    this.design["public_image"]["right"]='6.1mm';
    this.design["public_image"]["width"]='77';
    this.design["public_image"]["zindex"]='1';
    this.design['public_image']['QRcolorDark']="#432006";
    this.design['public_image']['QRcolorLight']="#EFEEEC";
    this.design['public_image']['QRCodeMargin']="3";
    this.design["key_image"]["width"]='77';
    this.design["key_image"]["top"]='12.2mm';
    this.design["key_image"]["left"]='8.1mm';
    this.design["key_image"]["zindex"]='1';
    this.design['key_image']['QRcolorDark']="#432006";
    this.design['key_image']['QRcolorLight']="#EFEEEC";
    this.design['key_image']['QRCodeMargin']="1";
    this.design["currency_name"]["top"]='19.8mm';
    this.design["currency_name"]["left"]='30.6mm';
    this.design["currency_name"]["width"]='80mm';
    this.design["address_data"]["top"]='24mm';
    this.design["address_data"]["right"]='75mm';
    this.design["address_data"]["bottom"]='auto';
    this.design["address_data"]["left"]='30.5mm';
    this.design["address_data"]["width"]='80mm';
    this.design["signature"]["width"]='180px';
    this.design["signature"]["container_width"]='57mm';
    this.design["signature"]["border"]=false;
    this.design["signature"]["label"]=false;
    this.design["signature"]["right"]='auto';
    this.design["signature"]["bottom"]='14.5mm';
    this.design["signature"]["left"]='96mm';
    this.design["micr"]["top"]='auto';
    this.design["micr"]["right"]='auto';
    this.design["micr"]["bottom"]='5.5mm';
    this.design["micr"]["left"]='10mm';
    this.design["micr"]["background"]=true;
    if(this.sql.model=='web') {
      var img = "statueofliberty";
      this.sql.load_background(img,(base64Img)=>{
        this.bg_image=base64Img;
      },this.sql.production);
    } else {
      this.bg_image = this.sql.production?backgrounds.statueofliberty:backgrounds_lowrez.statueofliberty;
    }
}
}